export * from './components/HorizontalBarChart/index';
